function timeToMinutes(s) {
	var m = /^(\d{1,2}):(\d{2})$/.exec(s ?? "");
	if (!m) { return NaN; }
	var h = Number(m[1]);
	var mn = Number(m[2]);
	if (h < 0 || h > 23 || mn < 0 || mn > 59) { return NaN; }
	return h * 60 + mn;
}

export function nextScheduleEntry(now, schedules) {
	var enabled = (schedules || []).filter((s) => s.enabled !== false && Number.isFinite(timeToMinutes(s.startTime)));
	if (!enabled.length) { return null; }
	var d = new Date(now);
	var todayMidnight = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
	var candidates = enabled.map((s) => {
		var todayFire = todayMidnight + timeToMinutes(s.startTime) * 60_000;
		var fireTs = todayFire > now ? todayFire : todayFire + 24 * 60 * 60_000;
		return { entry: s, fireTs };
	});
	candidates.sort((a, b) => a.fireTs - b.fireTs);
	return candidates[0];
}

export function resolveScheduledTarget(now, schedules) {
	if (!schedules || !schedules.length) { return null; }
	var enabled = schedules.filter((s) => s.enabled !== false && Number.isFinite(timeToMinutes(s.startTime)));
	if (!enabled.length) { return null; }
	var sorted = enabled.slice().sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));
	var d = new Date(now);
	var nowMin = d.getHours() * 60 + d.getMinutes();
	var active = null;
	for (var s of sorted) {
		if (timeToMinutes(s.startTime) <= nowMin) { active = s; }
	}
	if (!active) { active = sorted[sorted.length - 1]; }
	return active.targetTemp;
}
